/**
 * Normalizes a phone number to international format so it can be dialed
 * from the app. Numbers without a country code are assumed to be Dutch.
 */
export function toDialablePhone(phone?: string | null): string {
	if (!phone) return "";

	const trimmed = phone.trim();
	const hasPlus = trimmed.startsWith("+");
	let digits = trimmed.replace(/\D/g, "");

	if (!digits) return "";

	if (hasPlus || digits.startsWith("00")) {
		digits = hasPlus ? digits : digits.slice(2);
		// "+31 (0)6..." contains a trunk zero that must not be dialed
		if (digits.startsWith("310")) digits = `31${digits.slice(3)}`;
		return `+${digits}`;
	}
	if (digits.startsWith("31") && digits.length >= 11) {
		// "31 (0)6..." without a plus also contains the trunk zero
		if (digits.startsWith("310")) digits = `31${digits.slice(3)}`;
		return `+${digits}`;
	}
	if (digits.startsWith("0")) digits = digits.slice(1);

	return `+31${digits}`;
}
